const API_BASE_URL = process.env.REACT_APP_API_URL !== undefined ? process.env.REACT_APP_API_URL : "";
const MARKET_API_URL = process.env.REACT_APP_MARKET_API_URL !== undefined ? process.env.REACT_APP_MARKET_API_URL : "";

export { API_BASE_URL, MARKET_API_URL };
